import { Coordinate, ItemStatus, RawMeasurementQU, ServerObject, ShapeType } from './Common';

export enum FieldPermission {
  EDIT = 'EDIT',
  EDIT_WITHOUT_YIELD = 'EDIT_WITHOUT_YIELD',
  OWNER = 'OWNER',
}

export enum FieldFeature {
  CLU = 'CLU',
  CAB_APP = 'CabApp',
  CAB_APP_WEB_FEATURES = 'CabAppWebFeatures',
  CLOUD_SYNC = 'CloudSync',
  COVERAGE_STREAMING = 'CoverageStreaming',
  CURRENT_CONDITIONS = 'CurrentConditions',
  DATA_INBOX = 'DataInbox',
  DATA_INBOX_SOIL_TESTS = 'DataInboxSoilTests',
  FIELD_HEALTH_ADVISOR = 'FieldHealthAdvisor',
  FIELD_HEALTH_AVISOR_PROCESSING = 'FieldHealthAdvisorProcessing',
  FIELD_REGION_REPORT = 'FieldRegionReport',
  FIELD_VIEW_SPATIAL_DISPLAY = 'FieldViewSpatialDisplay',
  FORECAST = 'Forecast',
  HAIL = 'Hail',
  HISTORIC_WEATHER = 'HistoricWeather',
  MANUAL_SCRIPTING = 'ManualScripting',
  OTC = 'OTC',
  ONBOARDING = 'Onboarding',
  PLANTING = 'Planting',
  RADAR = 'Radar',
  RAINFALL = 'Rainfall',
  REMOTE_VIEW = 'RemoteView',
  SCOUTING = 'Scouting',
  SCOUTING_ADD_PHOTO = 'ScoutingAddPhoto',
  SHARE_FIELD_FILES = 'ShareFieldFiles',
  SOIL_MAP = 'SoilMap',
  SPLIT_VIEW = 'SplitView',
  WEATHER = 'Weather',
  YIELD_ANALYSIS = 'YieldAnalysis',
  PLANTING_REPORT = 'PlantingReport',
}

export type Field = ServerObject & {
  features: FieldFeature[];
  anomalies: string[];
  tenantId: string;
  timeZone: string;
  name: string;
  secondAdministrativeDivisionCode: string;
  source: {
    boundary: string;
    attributes: string;
  };
  boundary: {
    coordinates: Coordinate;
    bounds: Coordinate;
    type: ShapeType;
  };
  sourceMetadata: unknown;
  farmId: string;
  userUuid: string;
  centroid: {
    coordinates: [number, number];
  };
  status: ItemStatus;
  firstAdministrativeDivisionCode: string;
  userId: number;
  area: RawMeasurementQU;
  uuid: string;
  version: number;
  timestamp: number;
  enabled: boolean;
  countryCode: string;
  permission: FieldPermission;
};
